<template>
  <div class="LKPublicationsDataCollectionRight">
    <template v-if="isCurator">
      <div class="LKPublicationsDataCollectionRight__row">
        <div class="LKPublicationsDataCollectionRight__stats">
          <div>Всего: {{ toNumber(data.stats.all_count) }}</div>
          <div>Не приступило: {{ toNumber(data.stats.not_started_count) }}</div>
          <div>Не сдано: {{ toNumber(data.stats.overdue_count) }}</div>
          <div>В работе: {{ toNumber(data.stats.in_progress_count) }}</div>
          <div>Сдано: {{ toNumber(data.stats.submitted_count) }}</div>
        </div>

        <div class="LKPublicationsDataCollectionRight__chart">
          <!--
          <LKPublicationsDataCollectionStatsChart
            :data="data.stats"
            style="position: absolute;"
          />
          -->

          <button
            class="LKPublicationsDataCollectionRight__chart__btn"
            @click="onOpenFormdataListModal"
            v-text="'Список участников'"
          />

          <button
            class="LKPublicationsDataCollectionRight__chart__btn"
            @click="onOpenFormdataReportModal"
            v-text="'Экспорт результатов'"
          />

          <button
            class="LKPublicationsDataCollectionRight__chart__btn"
            @click="onOpenFormdataStatusReportModal"
            v-text="'Экспорт статусов'"
          />

          <button
            v-if="isFillingAvailable"
            class="LKPublicationsDataCollectionRight__chart__btn"
            :disabled="data.disabled && !data.form_data_status"
            @click="onGoToCreate"
            v-text="btnText"
          />
        </div>
      </div>
    </template>

    <template v-else>
      <div class="LKPublicationsDataCollectionRight__btn-container">
        <!--
        <button class="LKPublicationsDataCollectionRight__btn">
          <span
            class="LKPublicationsDataCollectionRight__btn-text"
            v-text="'Загрузить'"
          />
          <v-icon dark size="16px" v-text="'mdi-upload'" />
        </button>

        <button class="LKPublicationsDataCollectionRight__btn">
          <span
            class="LKPublicationsDataCollectionRight__btn-text"
            v-text="'Скачать'"
          />
          <v-icon dark size="16px" v-text="'mdi-download'" />
        </button>
        -->

        <button
          v-if="btnText"
          :disabled="data.disabled && !isSubmitted"
          class="LKPublicationsDataCollectionRight__btn"
          @click="onGoToCreate"
        >
          <span
            class="LKPublicationsDataCollectionRight__btn-text"
            v-text="btnText"
          />
          <v-icon dark size="16px" v-text="'mdi-square-edit-outline'" />
        </button>
      </div>

      <div
        v-if="description"
        class="LKPublicationsDataCollectionRight__bottom-text"
        v-html="description"
      />
    </template>
  </div>
</template>

<script>
import { FormdataStatuses } from '@/typings/api/Formdata'
import {
  createLKPublicationsFormdataListModal,
  LKPublicationsFormdataReportModal,
  LK_PUBLICATIONS_FORMDATA_ROUTES as ROUTES,
} from '@/views/LKPublications/formdata/utils'
import { uiDateFormatter } from '@/helpers/dateFormatter'
import { lkFormdataMapper as StoreMapper } from '../../formdata/store'
// import LKPublicationsDataCollectionStatsChart from './LKPublicationsDataCollectionStatsChart.vue'


const SUBMITTED_DESC_MAP = {
  DEFAULT: 'Вы можете заполнить форму. <br> Прием открыт.',
  DEFAULT_DISABLED: 'Сбор данных закрыт.',
  [FormdataStatuses.overdue]: 'Сбор данных завершен. <br> Вы просрочили отправку формы',
  [FormdataStatuses.prefilled]: 'Сбор данных завершен. <br> Вы не приступали к заполнению формы',
  [FormdataStatuses.open]: 'Вы можете заполнить форму. <br> Прием открыт.',
  [FormdataStatuses.in_progress]: 'Продолжите заполнение формы. <br> Прием открыт.',
  [FormdataStatuses.again_opened]: 'Продолжите заполнение формы. <br> Прием открыт.',
  [FormdataStatuses.arch]: 'Вы не можете заполнить форму. <br> Ваша форма в архиве.',
  [FormdataStatuses.close]: (form_data_submitted_at) => `Вы заполнили форму ${uiDateFormatter(form_data_submitted_at)} (мск).`,
  [FormdataStatuses.submitted]: (form_data_submitted_at) => `Вы заполнили форму ${uiDateFormatter(form_data_submitted_at)} (мск). <br> Идет сбор данных, вы можете отредактировать свой ответ.`,
}

const SUBMITTED_BTN_MAP = {
  DEFAULT: 'Заполнить',
  DEFAULT_DISABLED: 'Заполнить',
  [FormdataStatuses.in_progress]: 'Редактировать',
  [FormdataStatuses.submitted]: 'Редактировать',
  [FormdataStatuses.again_opened]: 'Редактировать',
  [FormdataStatuses.open]: 'Заполнить',
  [FormdataStatuses.prefilled]: 'Посмотреть',
  [FormdataStatuses.close]: 'Посмотреть',
  [FormdataStatuses.overdue]: 'Посмотреть',
}

export default {
  name: 'LKPublicationsDataCollectionRight',
  components: {
    // LKPublicationsDataCollectionStatsChart,
  },
  props: {
    isCurator: Boolean,
    isFillingAvailable: Boolean,
    publicationId: {
      type: [Number, String],
      default: null,
    },
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'id' in prop
        && 'disabled' in prop
        && 'form_data_id' in prop
        && 'form_template_id' in prop
        && 'form_data_submitted' in prop
      ),
    },
  },
  computed: {
    ...StoreMapper.mapState([
      'single',
    ]),
    description() {
      let { form_data_status } = this.data
      const { form_data_submitted_at, disabled } = this.data
      if (disabled && !form_data_submitted_at) return SUBMITTED_DESC_MAP.DEFAULT_DISABLED
      if (Date.parse(this.data.start_at) > Date.now()) return SUBMITTED_DESC_MAP.DEFAULT_DISABLED
      if (form_data_status) {
        if (form_data_status === FormdataStatuses.submitted && disabled) {
          form_data_status = FormdataStatuses.close
        }
        const status = SUBMITTED_DESC_MAP[form_data_status]
        return typeof status === 'function' ? status(form_data_submitted_at) : status
      }
      return disabled ? SUBMITTED_DESC_MAP.DEFAULT_DISABLED : SUBMITTED_DESC_MAP.DEFAULT
    },
    btnText() {
      let { form_data_status } = this.data
      const { disabled } = this.data
      if (Date.parse(this.data.start_at) > Date.now()) return SUBMITTED_BTN_MAP.DEFAULT_DISABLED
      if (form_data_status) {
        if (form_data_status === FormdataStatuses.submitted && disabled) {
          form_data_status = FormdataStatuses.close
        }
        return SUBMITTED_BTN_MAP[form_data_status]
      }
      return disabled ? SUBMITTED_BTN_MAP.DEFAULT_DISABLED : SUBMITTED_BTN_MAP.DEFAULT
    },
    isSubmitted() {
      return (this.data.form_data_status === FormdataStatuses.submitted
          || this.data.form_data_status === FormdataStatuses.close
          || this.data.form_data_status === FormdataStatuses.overdue
          || this.data.form_data_status === FormdataStatuses.again_opened)
          && (Date.parse(this.data.start_at) < Date.now())
    },
  },
  methods: {
    ...StoreMapper.mapActions(['opened']),
    toNumber(value) {
      return `${value}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    },
    onGoToCreate() {
      this.opened({ id: this.data.form_data_id })
      if (!this.data.form_data_status) {
        this.data.form_data_status = FormdataStatuses.in_progress
      }
      const location = {
        name: ROUTES.FORM,
        params: {
          ...this.$route.params,
          form_data_id: this.data.form_data_id,
          data_collection_id: this.data.id,
          form_template_id: this.data.form_template_id,
        },
      }

      this.$router.push(location)
    },
    async onOpenFormdataListModal() {
      const propsData = {
        data: this.data,
        title: this.data.name,
        publicationId: this.publicationId,
      }
      const modal = await createLKPublicationsFormdataListModal(this, propsData)
      await modal.open()
    },
    async onOpenFormdataReportModal() {
      const propsData = {
        reportCode: 'dataCollection',
        params: { data_collection_id: this.data.id },
        title: this.data.name,
      }
      const modal = await LKPublicationsFormdataReportModal(this, propsData)
      await modal.open()
    },
    async onOpenFormdataStatusReportModal() {
      const propsData = {
        reportCode: 'dataCollectionStatuses',
        params: { data_collection_id: this.data.id },
        title: `Статус заполнения: ${this.data.name}`,
      }
      const modal = await LKPublicationsFormdataReportModal(this, propsData)
      await modal.open()
    },
  },
}
</script>

<style lang="scss">
$right-width: 280px;

.LKPublicationsDataCollectionRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: $right-width;
  // text-align: center;

  &__row {
    display: flex;
    width: 100%;
  }

  &__stats {
    width: 100%;
    font-size: 12px;
    text-align: left;
  }

  &__bottom-text {
    margin-top: 8px;
    font-size: 12px;
    color: $webflow-color-blue-dark-2;
    text-align: center;
  }

  &__btn {
    padding: 8px 16px;
    margin: 4px;
    font-size: 12px;
    font-weight: 600;
    color: $webflow-color-white;
    background-color: $webflow-color-blue-dark;
    border-radius: 100px;
    transition: background-color $webflow-transition;

    &:hover {
      background-color: $webflow-color-blue-dark-hover;
    }

    &[disabled] {
      background-color: $webflow-color-grey;
    }

    & + & {
      margin-left: 12px;
    }

    &-text {
      margin-right: 8px;
    }
  }

  &__chart {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__btn {
      @extend .LKPublicationsDataCollectionRight__btn;

      & + & {
        margin: 4px;
      }
    }
  }
}
</style>
